import { TApiFolder } from "../../../api/endpoints/Folder";
import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder } from "@fortawesome/free-solid-svg-icons";
import Link from "../../Navigation/Links/Link";
import { paths } from "../../../router";
import dayjs from "dayjs";

const FolderList = (props: { folders: Array<TApiFolder> }) => {
  const { folders } = props;

  return (
    <Fragment>
      {
        folders.map(item => (
          <tr key={`folder-${item.id}`} className="order-browser-folder">
            <td className="folder-type"><FontAwesomeIcon icon={faFolder} className="type-icon" /></td>
            <td className="folder-name">
              <Link to={paths.ordersByFolder(item.id)}>
                {item.name}
              </Link>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="time">{dayjs(item.updated).fromNow()}</td>
            <td className="folder-actions"></td>
          </tr>
        ))
      }
    </Fragment>
  );
};

export default FolderList;
